//=include _ion.rangeSlider.min.js

$(document).ready(function() {
	$('.filtre_delete').on('click', function() {
		if ($(this).attr('rel').includes('|')) {
			$(this).attr('rel').split('|').forEach(function(item) {
				$('[name="' + item + '"]').val('');
				$('[name="' + item + '"]').removeAttr('checked');
				$('[name="' + item + '"] option').removeAttr('selected');
			});
		} else {
			$('[name="' + $(this).attr('rel') + '"]').val('');
			$('[name="' + $(this).attr('rel') + '"]').removeAttr('checked');
			$('[name="' + $(this).attr('rel') + '"] option').removeAttr('selected');
		}
		$('#form_filtres').submit();
	});

	$('.toggle_filtres').on('click', function(e) {
		$(this).toggleClass('active');
		$('.recherche_filtres').slideToggle();
	});

	$('#prix').ionRangeSlider();
});
